module.exports = __webpack_public_path__ + "static/media/Photoshop.22a86179.svg";